import { useDebouncedEffect } from "@react-hookz/web";
import { useEffect } from "react";
import { useStore } from "zustand";

import {
    GeneratingExploreWithAINotification,
    SuccessExploreWithAINotification,
} from "../../components/common/notification.components";
import { exploreWithAiStore } from "../../store/exploreWithAi";
import { navigationStore } from "../../store/navigation";
import { notificationStore } from "../../store/notification";
import { TopNavBarTabs } from "../../types/navigation";
import { isLoading, isSuccess } from "../../utils/api.utils";

export const useExploreWithAINotification = (): void => {
    const [storeAsyncStatus] = useStore(exploreWithAiStore, (state) => [
        state.asyncStatus,
    ]);

    const [upsertNotification, dismissNotification] = useStore(
        notificationStore,
        (state) => [state.upsertNotification, state.dismissNotification],
    );

    const [activeTab] = useStore(navigationStore, (state) => [state.activeTab]);

    useEffect(() => {
        if (isLoading(storeAsyncStatus)) {
            upsertNotification(
                <GeneratingExploreWithAINotification />,
                undefined,
                "generating-explore-with-ai-notification",
            );
        } else {
            dismissNotification("generating-explore-with-ai-notification");
            if (isSuccess(storeAsyncStatus)) {
                upsertNotification(
                    <SuccessExploreWithAINotification />,
                    undefined,
                    "success-explore-with-ai-notification",
                );
            }
        }
    }, [storeAsyncStatus]);

    useDebouncedEffect(
        () => {
            if (
                isSuccess(storeAsyncStatus) &&
                activeTab === TopNavBarTabs.EXPLORE_WITH_AI
            ) {
                dismissNotification("success-explore-with-ai-notification");
            }
        },
        [storeAsyncStatus, activeTab],
        2000,
    );
};
